/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Firma
 */
export interface Firma {
    /**
     * 
     * @type {number}
     * @memberof Firma
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Firma
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Firma
     */
    kuerzel: string;
}

/**
 * Check if a given object implements the Firma interface.
 */
export function instanceOfFirma(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "kuerzel" in value;

    return isInstance;
}

export function FirmaFromJSON(json: any): Firma {
    return FirmaFromJSONTyped(json, false);
}

export function FirmaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Firma {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'kuerzel': json['kuerzel'],
    };
}

export function FirmaToJSON(value?: Firma | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'kuerzel': value.kuerzel,
    };
}

